<lx-price-lists-portal-table-header title="Transfer service fees" [currency]="currency"></lx-price-lists-portal-table-header>
<ng-container [ngSwitch]="company">
  <lx-price-lists-portal-positively-transfer-table *ngSwitchCase="companyEnum.KIL" [transfers]="transfers"></lx-price-lists-portal-positively-transfer-table>
  <lx-price-lists-portal-alp-transfer-table *ngSwitchCase="companyEnum.ALP" [transfers]="transfers"></lx-price-lists-portal-alp-transfer-table>
</ng-container>
